// packages/firebase/index.ts
import { initializeApp, FirebaseApp } from "firebase/app";
import { getAuth, Auth } from "firebase/auth";
import { getConfig } from "@cabukaka/config";

let app: FirebaseApp | null = null;
let auth: Auth | null = null;

// Fonction à appeler après initConfig
export const initFirebase = () => {
  const ENV = getConfig();
  app = initializeApp(ENV.firebase);
  auth = getAuth(app);
  return { app, auth };
};

// Getter lazy (optionnel)
export const getFirebaseApp = () => {
  if (!app) throw new Error("Firebase not initialized. Call initFirebase() first.");
  return app;
};

export const getFirebaseAuth = () => {
  if (!auth) throw new Error("Firebase not initialized. Call initFirebase() first.");
  return auth;
};